module.exports = __webpack_public_path__ + "img/5-gray-cartoon.4234776b.png";